import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Alert,
} from "@mui/material";
import { stockTransferService } from "../service/StockTransferService";

 import { Container } from "@mui/system";
const StockTransfer = () => {
  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [search, setSearch] = useState("");

  // 🔥 Modal
  const [open, setOpen] = useState(false);
  const [selectedBike, setSelectedBike] = useState(null);
  const [toLocation, setToLocation] = useState("");

  // 🚀 Fetch stock
  const fetchStock = async () => {
    try {
      setLoading(true);
      const res = await stockTransferService.getShowroomStock();

      let bikes = [];
      res.data?.forEach((loc) => {
        bikes.push(...loc.bikes);
      });

      setData(bikes);
      setFiltered(bikes);

    } catch (err) {
      console.error(err);
      setError("Failed to load stock");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStock();
  }, []);

  // 🔍 Search filter
  const handleSearch = (value) => {
    setSearch(value);

    const filteredData = data.filter(
      (bike) =>
        bike.engine.toLowerCase().includes(value.toLowerCase()) ||
        bike.chasis.toLowerCase().includes(value.toLowerCase())
    );

    setFiltered(filteredData);
  };

  // 🔥 Open modal
  const handleOpen = (bike) => {
    setSelectedBike(bike);
    setOpen(true);
  };

  // 🔥 Transfer
  const handleTransfer = async () => {
    try {
      await stockTransferService.transferBike({
        bikeId: selectedBike._id,
        toLocation,
      });

      setOpen(false);
      setToLocation("");
      fetchStock();

    } catch (err) {
      alert(err.response?.data?.message || "Transfer failed");
    }
  };

  return (
  <Container maxWidth="lg">          <Typography variant="h4" gutterBottom>
        Stock Transfer
      </Typography>

      {/* 🔍 SEARCH */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <TextField
          label="Search Engine / Chasis"
          fullWidth
          value={search}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </Paper>

      {loading && <CircularProgress />}
      {error && <Alert severity="error">{error}</Alert>}

      {/* 📊 TABLE */}
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Model</TableCell>
              <TableCell>Engine</TableCell>
              <TableCell>Chasis</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filtered.map((bike) => (
              <TableRow key={bike._id}>
                <TableCell>{bike.model}</TableCell>
                <TableCell>{bike.engine}</TableCell>
                <TableCell>{bike.chasis}</TableCell>
                <TableCell>{bike.location}</TableCell>

                <TableCell>
                  <Button
                    variant="contained"
                    onClick={() => handleOpen(bike)}
                  >
                    Transfer
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>

        </Table>
      </Paper>

      {/* 🔥 MODAL */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Transfer Bike</DialogTitle>

        <DialogContent>
          <Typography>
            Engine: {selectedBike?.engine}
          </Typography>

          <TextField
            label="To Location"
            fullWidth
            value={toLocation}
            onChange={(e) => setToLocation(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>

          <Button variant="contained" onClick={handleTransfer}>
            Confirm Transfer
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default StockTransfer;